import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isProductOutOfStock } from "../../utils/productAvailability";

const ProductCard = ({ product, selected, onToggle }) => {
    const { t } = useTranslation();
    const outOfStock = isProductOutOfStock(product);

    return (
        <button
            type="button"
            onClick={() => {
                if (outOfStock) return;
                onToggle(product.id);
            }}
            disabled={outOfStock}
            className={`group relative flex min-h-[370px] flex-col items-center rounded-3xl border bg-white px-5 py-6 text-center shadow-[0_10px_20px_rgba(15,23,42,0.06)] transition md:px-6 md:py-8 ${
                outOfStock
                    ? "cursor-not-allowed border-slate-200"
                    : selected
                        ? "border-primary ring-1 ring-primary focus:outline-none"
                        : "border-slate-200 hover:-translate-y-0.5 hover:shadow-[0_18px_30px_rgba(15,23,42,0.08)] focus:outline-none"
            }`}
        >
            {!outOfStock ? (
                <span
                    className={`absolute right-4 top-4 flex h-5 w-5 items-center justify-center rounded-full border md:right-5 md:top-5 ${
                        selected ? "border-primary bg-primary text-white" : "border-slate-300 text-transparent"
                    }`}
                >
                    <Check className="h-3 w-3" />
                </span>
            ) : null}
            <div className="flex w-full flex-1 flex-col items-center">
                <div className={`flex w-full items-center justify-center ${outOfStock ? "pt-6" : "pt-2"}`}>
                    <img
                        src={product.image}
                        alt=""
                        className={`max-h-16 object-contain md:max-h-20 ${outOfStock ? "opacity-55 grayscale" : ""}`}
                    />
                </div>
                <p
                    title={product.name}
                    className={`mt-6 min-h-[3.8rem] max-w-[190px] overflow-hidden text-ellipsis whitespace-normal break-words font-medium leading-[1.25] text-slate-900 line-clamp-2 ${outOfStock ? "text-sm" : "text-base"}`}
                >
                    {product.name}
                </p>
                <p className={`mt-2 text-xs ${outOfStock ? "text-slate-400" : "text-slate-500"}`}>
                    {t("COMMON_CODE")}: {product.code}
                </p>
                {!outOfStock ? (
                    <>
                        <p className="mt-6 text-sm font-medium text-primary">
                            {t("COMMON_GIFT_VALUE")}: {product.price}
                        </p>
                        {product.link ? (
                            <a
                                href={product.link}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                className="mt-6 text-sm text-slate-700 underline underline-offset-4 hover:opacity-75"
                            >
                                {t("COMMON_SEE_ONLINE")}
                            </a>
                        ) : (
                            <span className="mt-6 text-sm text-slate-700 underline underline-offset-4">
                                {t("COMMON_SEE_ONLINE")}
                            </span>
                        )}
                    </>
                ) : (
                    <span className="mt-auto pb-2 text-sm pt-10 text-slate-400">
                        {t("COMMON_OUT_OF_STOCK")}
                    </span>
                )}
            </div>
        </button>
    );
};

export default ProductCard;
